<template>
  <main class="login">
    <section class="login__card" role="form" aria-labelledby="login-title">
      <h1 id="login-title" class="login__title">로그인</h1>

      <!-- 안내/에러 (디자인용 샘플, 필요시 보이도록) -->
      <!-- <p class="login__notice">세션이 만료되었습니다. 다시 로그인하세요.</p> -->
      <!-- <p class="login__error" role="alert">이메일 또는 비밀번호가 올바르지 않습니다.</p> -->

      <!-- 이메일 -->
      <label class="login__label" for="email">이메일</label>
      <div class="login__field">
        <input id="email"
        v-model="email"
        type="email" autocomplete="username" inputmode="email" placeholder="이메일을 입력하세요" />
      </div>
      <!-- <p class="login__hint" role="alert">이메일을 입력하세요.</p> -->

      <!-- 비밀번호 -->
      <label class="login__label" for="password">비밀번호</label>
      <div class="login__field login__field--password">
        <input id="password" 
        :type="showPassword ? 'text' : 'password'"
        v-model="password" 
        autocomplete="current-password" placeholder="비밀번호를 입력하세요"  @keyup.enter="goLogin" />
        <button class="togglepw" type="button" aria-pressed="false" @click="showPassword = !showPassword">
          <i class="fa-regular fa-eye" aria-hidden="true"></i>
          <span class="sr-only">비밀번호 표시</span>                                                                                                                                                                                     
        </button>
      </div>
      <!-- <p class="login__hint" role="alert">비밀번호를 입력하세요.</p> -->

      <!-- 옵션 -->
      <div class="login__options">
        <div class="link" @click="router.push('/findid')">아이디 찾기</div>

        <div class="link" @click="router.push('/reset-password')">비밀번호 찾기</div>
      </div>

      <!-- 액션 -->
      <div class="login__actions">
        <button class="login__btn" @click="goLogin">로그인</button>
        <button class="ghost" @click="goJoin">회원가입</button>
      </div>
    </section>
  </main>
</template>

<script setup>
import { ref, computed } from 'vue'
import { loginUser } from '@/api/user'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
// 간단한 커스터마이즈 가능 값 (원하면 props로 변경)
const title = '로그인'
const subtitle = '서비스에 접속하려면 계정 정보를 입력하세요.'
const logoSrc = '' // '/logo.svg' 처럼 경로를 넣으면 로고가 표시됩니다.

const email = ref('')
const password = ref('')
const remember = ref(false)
const showPassword = ref(false)
const loading = ref(false)
const errorMsg = ref('')
const showErrors = ref(false)

const router = useRouter()
const store = useStore()


const emailValid = computed(() =>
  /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.value)
)
const passwordValid = computed(() => password.value.length >= 6)

const checkField = () => {
  if (email.value == '') {
    alert("이메일 입력해주세요")
    return false
  }
  if (password.value == '') {
    alert("비밀번호를 입력해주세요")
    return false
  }
  return true
}

const goJoin = () => {
  router.push('/join-step1')
}

const goLogin = async () => {
  if (!checkField()) { return false }

  let param = {
    email: email.value,
    passwordHash: password.value
  }
  const resultVo = await loginUser(param)

  if (resultVo?.result == 'ok') {
    alert(resultVo.resultMsg)
    //console.log("맴버 코드" ,resultVo.data.memberCode)
    store.commit('temp/setUserInfo', { key: 'userId', value: resultVo.data.userId })
    store.commit('temp/setUserInfo', { key: 'userName', value: resultVo.data.userName })
    store.commit('temp/setUserInfo', { key: 'email', value: resultVo.data.email })
    store.commit('temp/setUserInfo', { key: 'userType', value: resultVo.data.userType })
    store.commit('temp/setUserInfo', { key: 'corporateId', value: resultVo.data.corporateId })
    store.commit('temp/setUserInfo', { key: 'planId', value: resultVo.data.planId })
    store.commit('temp/setUserInfo', { key: 'status', value: resultVo.data.status })
    store.commit('temp/setUserInfo', { key: 'createdAt', value: resultVo.data.createdAt })
    store.commit('temp/setUserInfo', { key: 'updatedAt', value: resultVo.data.updatedAt })
    store.commit('temp/setUserInfo', { key: 'phone', value: resultVo.data.phone })
    store.commit('temp/setUserInfo', { key: 'orgName', value: resultVo.data.orgName })
    store.commit('temp/setUserInfo', { key: 'position', value: resultVo.data.position })
    store.commit('temp/setUserInfo', { key: 'orgPhone', value: resultVo.data.orgPhone })
    store.commit('temp/setUserInfo', { key: 'zoneCode', value: resultVo.data.zoneCode })
    store.commit('temp/setUserInfo', { key: 'address', value: resultVo.data.address })
    store.commit('temp/setUserInfo', { key: 'extraAddress', value: resultVo.data.extraAddress })
    store.commit('temp/setUserInfo', { key: 'detailAddress', value: resultVo.data.detailAddress })
    store.commit('temp/setUserInfo', { key: 'gender', value: resultVo.data.gender })

    router.push('/');
    // if(resultVo.data.privilege == 'sAdmin'){
    //   router.push({ name: 'organization' }).then(() => {
    //     window.location.reload(); // 강제 새로고침
    //   });
    // }else if(resultVo.data.privilege == 'admin'){
    //   router.push({ name: 'IQCgiasInput' }).then(() => {
    //     window.location.reload(); // 강제 새로고침
    //   });
    // }else{
    //   router.push({ name: 'IQAgiasInput' }).then(() => {
    //     window.location.reload(); // 강제 새로고침
    //   });
    // }

  } else {
    //alert("실패")
    alert(resultVo.resultMsg)
  }
}

</script>

<style scoped>
/* 시스템 폰트 스택(상업적 무료) */
.login {
  font-family: system-ui, -apple-system, "Segoe UI", "Noto Sans KR",
    "Apple SD Gothic Neo", "Malgun Gothic", Arial, sans-serif;
  display: grid;
  place-items: center;
  padding: 48px 16px;
  background: #f8fafc;
}

.login__card {
  width: 100%;
  max-width: 580px;
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 16px;
  padding: 64px 36px;
  box-shadow: 0 10px 30px rgba(17, 24, 39, .06);
}

.login__title {
  margin: 0 0 24px;
  font-size: 1.5rem;
  font-weight: 800;
  letter-spacing: -.2px;
  color: #0f172a;
}

/* 알림/에러 박스 (디자인용) */
.login__notice {
  margin: 4px 0 12px;
  font-size: .95rem;
  color: #334155;
  background: #eef2ff;
  border: 1px solid #c7d2fe;
  border-radius: 10px;
  padding: 10px 12px;
}
.login__error {
  margin: 4px 0 12px;
  font-size: .95rem;
  color: #b91c1c;
  background: #fef2f2;
  border: 1px solid #fecaca;
  border-radius: 10px;
  padding: 10px 12px;
}

.login__label {
  display: block;
  margin: 14px 0 8px;
  font-weight: 700;
  font-size: .95rem;
  color: #0f172a;
}

.login__field { position: relative; }

.login__field input {
  width: 100%;
  height: 58px;
  padding: 0 0 0 16px;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  font-size: 17px;
  color: #0f172a;
  background: #fff;
  transition: border-color .15s ease, box-shadow .15s ease;
}
.login__field input::placeholder { color: #94a3b8; }
.login__field input:focus {
  outline: none;
  border-color: #a5b4fc;
  box-shadow: 0 0 0 4px rgba(99, 102, 241, .15);
}

/* .login__field--password input { padding-right: 44px; } */

/* 비밀번호 보기 토글 (동작 없이 디자인만) */
.togglepw {
  position: absolute;
  right: 6px;
  top: 50%;
  transform: translateY(-50%);
  height: 40px;
  width: 40px;
  border-radius: 8px;
  border: 1px solid #e5e7eb;
  background: #fff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.togglepw:hover { background: #f8fafc; }
.togglepw:focus-visible {
  outline: 3px solid rgba(99, 102, 241, .25);
  outline-offset: 2px;
}

.login__hint {
  margin: 6px 0 0;
  font-size: .85rem;
  color: #b91c1c;
}

/* 옵션 라인 */
.login__options {
  margin: 14px 0 0;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
}
.remember {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  color: #334155;
  font-size: .95rem;
}
.link {
  background: transparent;
  border: 0;
  color: #1d2088;
  text-decoration: underline;
  font-weight: 600;
  cursor: pointer;
}

/* 액션 버튼 */
.login__actions {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  margin-top: 32px;
}
.login__btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 52px;
  font-size: 16px;
  font-weight: 700;
  border-radius: 12px;
  border: 0;
  color: #fff;
  background: #1d2088;
  transition: background .15s ease;
}
.login__btn:hover { background: #220e52; }

.login__btn,
.ghost {
  height: 58px;        /* 버튼 높이 (52 → 58) */
  font-size: 17px;
  border-radius: 14px; /* 버튼 모서리도 살짝 크게 */
  cursor: pointer;
}

.ghost {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 52px;
  padding: 0 14px;
  border-radius: 12px;
  border: 1px solid #e5e7eb;
  background: #fff;
  font-weight: 700;
  color: #0f172a;
  transition: background .15s ease, border-color .15s ease;
}
.ghost:hover { background: #f8fafc; border-color: #cbd5e1; }

/* 모바일 */
@media (max-width: 480px) {
  .login__card { padding: 24px 16px; }
  .login__actions { grid-template-columns: 1fr; }
}

/* 접근성 유틸 */
.sr-only {
  position: absolute; width: 1px; height: 1px; padding: 0; margin: -1px;
  overflow: hidden; clip: rect(0,0,0,0); white-space: nowrap; border: 0;
}
</style>
